import { lazy } from 'react';

export const PlayerRgRiskLevelForm = lazy(
  () => import('./PlayerRgRiskLevelForm'),
);
